/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_Commit_Status_FailedInputs */

const en_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commit status failed: ${i?.message}`)
};

const fr_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’état du commit : ${i?.message}`)
};

const de_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commit-Status fehlgeschlagen: ${i?.message}`)
};

const it_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stato di commit non riuscito: ${i?.message}`)
};

const ru_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Статус фиксации: ${i?.message}`)
};

const es_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado de confirmación fallido: ${i?.message}`)
};

const zh_cn2_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交状态失败：${i?.message}`)
};

const ja_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コミットステータスに失敗しました: ${i?.message}`)
};

const hi_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कमिट स्थिति विफल: ${i?.message}`)
};

const pt_pt2_team_sync_commit_status_failed = /** @type {(inputs: Team_Sync_Commit_Status_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status da confirmação falhou: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Commit status failed: {message}" |
*
* @param {Team_Sync_Commit_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_status_failed = /** @type {((inputs: Team_Sync_Commit_Status_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Status_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_commit_status_failed(inputs)
	if (locale === "de") return de_team_sync_commit_status_failed(inputs)
	if (locale === "it") return it_team_sync_commit_status_failed(inputs)
	if (locale === "ru") return ru_team_sync_commit_status_failed(inputs)
	if (locale === "es") return es_team_sync_commit_status_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_commit_status_failed(inputs)
	if (locale === "ja") return ja_team_sync_commit_status_failed(inputs)
	if (locale === "hi") return hi_team_sync_commit_status_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_commit_status_failed(inputs)
	return en_team_sync_commit_status_failed(inputs)
});